function mainNavHelperMobile() {
  const navParent = document.querySelector('.navbar');
  if (!navParent) return;

  const navParents = document.querySelectorAll('.navbar-item.has-dropdown');
  const activeClass = 'is-active';

  function toggleNavVisibility(clickedTrigger) {
    navParents.forEach((navItem) => {
      const trigger = navItem.querySelector('.navbar-parent');
      if (clickedTrigger === trigger) {
        navItem.classList.toggle(activeClass);
      } else {
        navItem.classList.remove(activeClass);
      }
    });
  }

  function closeAllNavs() {
    navParents.forEach((navItem) => {
      navItem.classList.remove(activeClass);
    });
  }

  navParents.forEach((navItem) => {
    const trigger = navItem.querySelector('.navbar-parent');
    const newTrigger = trigger.cloneNode(true);
    trigger.parentNode.replaceChild(newTrigger, trigger);

    newTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleNavVisibility(this);
    });
  });

  document.addEventListener('click', function (event) {
    const clickedLink = event.target.closest('a');
    const isDropdownLink = clickedLink && clickedLink.closest('.navbar-dropdown');
    if (isDropdownLink) return;

    const isInsideDropdown = event.target.closest('.navbar-dropdown');
    if (!isInsideDropdown) {
      closeAllNavs();
    }
  });

  document.addEventListener('focusin', function (event) {
    const isInsideDropdown = event.target.closest('.navbar-dropdown');
    if (!isInsideDropdown) {
      closeAllNavs();
    }
  });
}

export default mainNavHelperMobile;
